<template>
    <div v-if="sheba_numbers">
    <kt-row>
        <kt-col xs="12" sm="6" md="4" v-for="(bank_account, index) in bank_accounts"
        v-bind:key="index">
            <kt-panel>
                <kt-panel-body class="text-center shadow-sm">
                    <kt-row>
                        <kt-col xs="12" v-if="bank_account.shebaNumber">
                            {{ $t('panel.profile.bankAccount.shebaNumber') }} : {{ correctFormatSheba(bank_account.shebaNumber) }}
                        </kt-col>
                        <kt-col xs="12" v-if="bank_account.accountNumber">
                            {{ $t('panel.profile.bankAccount.accountNumber') }} : {{bank_account.accountNumber}}
                        </kt-col>
                    </kt-row>
                    <span class="badge badge-primary">
                        {{ getBankName(correctFormatSheba(bank_account.shebaNumber)) }}
                    </span>
                    <span v-if="bank_account.iban_inquiry_status_code ===INVALID" style="margin-top: 20px" class="badge badge-danger">
                        {{ $t('panel.iban_inquiry') }}  : {{ bank_account.iban_inquiry_status }}
                    </span>
                    <span v-if="bank_account.iban_inquiry_status_code ===VALID" style="margin-top: 20px" class="badge badge-success">
                        {{ $t('panel.iban_inquiry') }}  : {{ bank_account.iban_inquiry_status }}
                    </span>
                    <span v-if="bank_account.iban_inquiry_status_code ===INDETERMINATE" style="margin-top: 20px" class="badge badge-warning">
                        {{ $t('panel.iban_inquiry') }}  : {{ bank_account.iban_inquiry_status }}
                    </span>
                    <div class="d-flex justify-content-center">
                      <form  class="kt-form"  @submit.prevent="submit($event,bank_account.sheba_id)">
                         <kt-form-action  class="mt-4 d-flex justify-content-center align-items-center">
                           <i @click.prevent="submit($event,bank_account.sheba_id)" id="iban_inquiry_form"
                              :title="$t('panel.sending_iban_inquiry')" class="fas fa-sync pl-2"
                              style="color: #4CAF50;">
                           </i>&nbsp;
                        </kt-form-action>
                      </form>

                      <button
                          v-if="isAccessManageable(correctFormatSheba(bank_account.shebaNumber))"
                          :disabled="!disableBankAccountsBtn(bank_account.shebaNumber)"
                          class="btn p-0 m-0 text-danger pr-2 mt-3"
                          type="button"
                          id="bank_accounts_access_btn"
                          @click="bankAccountsManageAccess(bank_account, getNickBankName(correctFormatSheba(bank_account.shebaNumber)))"
                      >
                        <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                          <span v-if="disableBankAccountsBtn(bank_account.shebaNumber)" class="tooltip-text">{{ $t('label.bank_accounts_access') }}</span>
                          <span v-else class="tooltip-text">کاربر دسترسی نداده است.</span>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-shield-lock-fill" viewBox="0 0 20 20">
                              <path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z"/>
                            </svg>
                          </span>
                        </span>
                      </button>
                        <button type="submit" class="btn p-0 m-0 text-danger pr-2 mt-3" @click="deleteIban(bank_account)">
                            <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <span  class="tooltip-text">حذف شبا</span>
                                <i class="fa flaticon-delete text-danger"></i>
                            </span>
                        </button>
                    </div>
                </kt-panel-body>
            </kt-panel>
        </kt-col>
    </kt-row>

    <!-- Modal -->
    <!-- Saderat -->
    <SaderatBankAccountsAccessModal :bank_accounts_access="bank_accounts_access" @storeBankAccountsAccess="storeBankAccountsAccess" />
    <AyandeBankAccountsAccessModal :bank_accounts_access="bank_accounts_access" @storeBankAccountsAccess="storeBankAccountsAccess" />
    <SamanBankAccountsAccessModal :bank_accounts_access="bank_accounts_access" @storeBankAccountsAccess="storeBankAccountsAccess" />
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {IbanInquiryStatus} from '@/constants/IbanInquiryStatus'
import {bankAccountsAccessTokenService, userService} from '@/common/api.service'
import IranSheba from 'iran-sheba'
import toastr from "toastr";
import $ from 'jquery'
import SaderatBankAccountsAccessModal from "@/views/user/components/banks/SaderatBankAccountsAccessModal.vue";
import AyandeBankAccountsAccessModal from "@/views/user/components/banks/AyandeBankAccountsAccessModal.vue";
import SamanBankAccountsAccessModal from "@/views/user/components/banks/SamanBankAccountsAccessModal.vue";
import {KTApp} from "@/plugins/core/app";

export default {
  components: {SamanBankAccountsAccessModal, AyandeBankAccountsAccessModal, SaderatBankAccountsAccessModal},
    data() {
        return {
            sheba_numbers: [],
            bank_accounts: {},
            INVALID:IbanInquiryStatus.INVALID,
            VALID:IbanInquiryStatus.VALID,
            INDETERMINATE:IbanInquiryStatus.INDETERMINATE,
            bank_accounts_access: {
                additional_credential: {}
            },
            current_bank_name: null,
            manageAccessableBankNames: ['ayandeh', 'saderat', 'saman']
        }
    },
    computed: {
        ...mapGetters('user', [
            'user'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
       this.fetchBankAccounts()
    },
    methods: {
      deleteIban(bank_account) {
          let params = {
              user_id: this.$route.params.hashid
          }
          userService.adminDeleteIban(bank_account.sheba_id, params)
              .then(({data}) => {
                  this.toastr.success(data.message)
                  this.fetchBankAccounts()
              }).catch(({response}) => {
              this.toastr.error(response.data.message)
          })
      },
        fetchBankAccounts() {
            userService.fetchShebaNumbers(this.user.id).then(
                response => {
                    this.sheba_numbers = response.data.data
                }
            )
            userService.fetchBankAccounts(this.user.id).then(
                response => {
                    this.bank_accounts = response.data.data
                }
            )
        },
        disableBankAccountsBtn(sheba_number){
          return this.sheba_numbers.find(function (item) {
            if (item.bank_accounts_access) {
              if (item.number == 'IR' + sheba_number.replace(/-/g, '')) {
                return (item && item.bank_accounts_access.status != 4)
              }
            }
          })
        },
        storeBankAccountsAccess() {
          let form = $('#bank_accounts_access_form_' + this.current_bank_name)
          let btn = $('#store_bank_accounts_access_btn')

          form.validate({
            rules: {
              account_number: {
                required: true,
                number: true,
              }
            }
          })

          if(!form.valid()) {
            return
          }

          btn.prop("disabled", true);
          btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

          bankAccountsAccessTokenService.adminStoreBankAccountsAccess(this.bank_accounts_access.id, this.bank_accounts_access)
              .then((response) => {
                $('#bank-accounts-access-modal_' + this.current_bank_name).modal('hide')
                userService.fetchShebaNumbers(this.user.id).then(
                    response => {
                      this.sheba_numbers = response.data.data
                    }
                )
                this.toastr.success(response.data.message)
              })
              .catch((error) => {
                if (error.response.data.data)
                  form.validate().showErrors(error.response.data.data)
                else
                  this.toastr.error('خطای سرور!')
              })
              .finally(() => {
                btn.prop("disabled", false);
                btn.html(this.$t('btn.edit'));
              })
        },

        bankAccountsManageAccess(bankAccount, bankName){
          $('#bank_accounts_access_form_' + bankName).validate().resetForm();
          this.current_bank_name = bankName
          $('#bank-accounts-access-modal_' + bankName).modal('show')
          let sheba_number = this.sheba_numbers.find(function (item) {
            if (item.bank_accounts_access){
              if (item.number == 'IR' + bankAccount.shebaNumber.replace(/-/g,'')) {
                return item
              }
            }
          })

          this.bank_accounts_access = {
            id: sheba_number.bank_accounts_access ? sheba_number.bank_accounts_access.id : null,
            iban_number: sheba_number.number,
            // bank_id: bankId[this.getBankNickname(sheba_number.number)],
            account_number: sheba_number.bank_accounts_access ? sheba_number.bank_accounts_access.account_number : null,
            status: sheba_number.bank_accounts_access ? sheba_number.bank_accounts_access.status : null,
            deactivate_access: sheba_number.bank_accounts_access ? sheba_number.bank_accounts_access.deactivate_access : null,
            additional_credential: sheba_number.bank_accounts_access.additional_credential ? sheba_number.bank_accounts_access.additional_credential : null,
          }
        },

        getBankName(number) {
            return IranSheba.recognize(number)['persianName']
        },
        getNickBankName(number) {
          return IranSheba.recognize(number)['nickname']
        },
        correctFormatSheba(sheba) {
            return 'IR' + sheba.split('-').join('')
        },
        correctFormatCardNumber(cardNumber) {
            return cardNumber.split('-').join('')
        },
        submit(e,sheba_id) {
            let params ={
                merchant_or_related:'merchant',
                merchant_id:this.user.id,
                sheba_id:sheba_id
            }
            userService.ibanInquiry(params).then(response => {
                this.toastr.success(response.data.message)
                userService.fetchBankAccounts(this.user.id).then(
                        response => {
                            this.bank_accounts = response.data.data
                        }
                )
            })
                    .catch(({response}) => {
                        if(response.data) {
                            this.toastr.error(response.data.message)
                            userService.fetchBankAccounts(this.user.id).then(
                                    response => {
                                        this.bank_accounts = response.data.data
                                    }
                            )

                        }
                        this.toastr.error(response.data.message)
                        userService.fetchBankAccounts(this.user.id).then(
                                response => {
                                    this.bank_accounts = response.data.data
                                }
                        )
                    })
        },
        isAccessManageable(bankNumber){
            const bankName = this.getNickBankName(bankNumber)
            return Object.values(this.manageAccessableBankNames).includes(bankName)
        },

    }
}
</script>

<style>
  .color {
    color: #9f0000
  }
</style>